<h1 i18n>Register</h1>

<p i18n>Enter your details in the form below to create a new user account.</p>

<p>
    <span i18n>Already have an account?</span>
    <a routerLink="/login" class="ms-1" i18n>Sign in</a>
</p>

<form [formGroup]="form" (ngSubmit)="submit()">
    <div class="mb-2">
        <label for="username" class="form-label" i18n>Username</label>
        <input
            type="text"
            id="username"
            class="form-control"
            [class.is-invalid]="
                form.controls.username.touched && form.controls.username.invalid
            "
            [formControl]="form.controls.username"
        />
        @for (error of usernameErrors$ | async; track $index) {
        <p class="invalid-feedback">
            {{ error }}
        </p>
        }
    </div>
    <div class="mb-2">
        <label for="email" class="form-label" i18n>Email</label>
        <input
            type="email"
            id="email"
            class="form-control"
            [class.is-invalid]="
                form.controls.email.touched && form.controls.email.invalid
            "
            [formControl]="form.controls.email"
        />
        @for (error of emailErrors$ | async; track $index) {
        <p class="invalid-feedback">
            {{ error }}
        </p>
        }
    </div>
    <div class="mb-2">
        <label for="password1" class="form-label" i18n>Password</label>
        <input
            type="password"
            id="password1"
            class="form-control"
            [class.is-invalid]="
                form.controls.password1.touched &&
                form.controls.password1.invalid
            "
            [formControl]="form.controls.password1"
        />
        @for (error of password1Errors$ | async; track $index) {
        <p class="invalid-feedback">
            {{ error }}
        </p>
        }
    </div>
    <div>
        <label for="password2" class="form-label" i18n>Confirm Password</label>
        <input
            type="password"
            class="form-control"
            id="password2"
            [class.is-invalid]="
                form.controls.password2.touched &&
                form.controls.password2.invalid
            "
            [formControl]="form.controls.password2"
        />
        @for (error of password2Errors$ | async; track $index) {
        <p class="invalid-feedback">
            {{ error }}
        </p>
        }
    </div>
    @for (error of formErrors$ | async; track $index) {
    <p class="invalid-feedback always-block">
        {{ error }}
    </p>

    }
    <button type="submit" class="btn btn-primary my-3">
        <span i18n>Register</span>
        @if (loading$ | async) {
        <div class="spinner-border spinner-border-sm ms-1" role="status">
            <span class="visually-hidden" i18n>Registering...</span>
        </div>
        }
    </button>
</form>
